import { getExternalMediaProviderPolicy } from "./ExternalMediaProviderRegistry";
import type { ClassifiedExternalMediaNode } from "./ExternalMediaTypes";

export function classifyExternalMediaNode(nodeType: string | null | undefined): ClassifiedExternalMediaNode | null {
    const policy = getExternalMediaProviderPolicy(nodeType);
    if (!policy) {
        return null;
    }

    return {
        nodeType: policy.nodeType,
        providerId: policy.providerId,
        renderKind: policy.renderKind,
        isAdultProvider: policy.isAdultProvider,
        isSensitiveByDefault: policy.isSensitiveByDefault,
    };
}
